import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Layout,
  Menu,
  Modal,
  Row,
  Space,
  Table,
  Typography,
  notification,
  Switch
} from 'antd';
import {
  CopyOutlined,
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  ExportOutlined,
  StarFilled,
  StarOutlined
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import {withRouter} from 'react-router-dom';
import React from 'react';
import '../App.css';
import { API } from '../api';
import { USER_ROLE } from '../consts';
import { checkPermission, copyToClipboard, exportAllMappings, fetchUserPreferences, filterUserPreferences, isAdmin, logGAEvent } from '../utils/util';
import {DimaContext} from "../DimaContext";
import { isEmpty } from 'lodash';

const { Title, Text } = Typography;

class Home extends React.Component {
  static contextType = DimaContext;
  formRef = React.createRef();

  state = {
    isModalVisibleNew: false,
    isModalVisibleDel: false,
    isModalVisibleEdit: false,
    isModalVisibleEditName: false,
    isModalVisibleEditClient: false,
    isModalVisibleEditAwsAccountId: false,
    isModalVisibleEditDisApi: false,
    isLoadingNewClient: false,
    isLoadingDelClient: false,
    newClientName: null,
    newClientFHIRURL: null,
    newClientAWSAccountId: null,
    newDisApiUrl: '',
    editClientName: null,
    delClientName: null,
    initLoading: true,
    placeHolder: null,
    submitDisabled: true,
    clientListAll: [],
    /**
     * List of all non-deleted clients
     */
    clientList: [],
    /**
     * Text that the user is searching for
     */
    clientSearchText: '',
    client: null,
    title: null,
    permissionsLoaded: false,
    favoriteClients: [],
    filterFavorites: false,
    columns: this.generateColumns(),
  };

  componentDidMount() {
    document.title = 'DIMA';
    return this.getData();
  }

  componentDidUpdate(prev) {
    const cntxFavClients = filterUserPreferences('favorite_client', this.context.userData.preferences)
    const { permissionsLoaded, favoriteClients } = this.state;
    
    let newState = {};
    // Once user data has been fetched and set in context, reset the columns to reflect the user's permissions & preferences
    if (this.context.userData.loaded) {
      if (!permissionsLoaded) {
        newState = { permissionsLoaded: true };
      }
      if (favoriteClients.length !== cntxFavClients.length) {
        newState = {...newState, favoriteClients: cntxFavClients}
      }
      if (!isEmpty(newState)) {
        newState = { ...newState, columns: this.generateColumns() }
        this.setState(newState)
      }
    }
  }

  generateColumns() {
    const canEditClient = process.env.REACT_APP_FEATURE_PERMISSIONS_V2 ?
      checkPermission(this.context.userData.permissions, 'editClient') :
      isAdmin(USER_ROLE);

      return (
      [
        {
          title: 'ID',
          dataIndex: 'id',
          render: value => (
            <span className="click-active" onClick={() => copyToClipboard(value)}>
              <CopyOutlined /> {value}
            </span>
          ),
        },
        {
          title: 'Name',
          dataIndex: 'name',
          defaultSortOrder: 'ascend',
          sorter: (a, b) => {
            if (!!a.name && !!b.name) {
              return a.name.localeCompare(b.name);
            }
  
            return null;
          },
        },
        {
          title: 'AWS Account Id',
          dataIndex: 'aws_account_id',
        },
        {
          title: 'FHIR API URL',
          dataIndex: 'fhir_api_url',
        },
        {
          title: 'Action',
          width: 100,
          render: (_value, record) => {
            const { preferences } = this.context.userData;
            const favoriteClient = filterUserPreferences('favorite_client', preferences).find(({ value }) => value === record.id);
            const favoriteIcon = !!favoriteClient ? <StarFilled style={{ color: "gold" }} /> : <StarOutlined />
            return (
              <Space size="middle">
                <Dropdown.Button
                  trigger={['click']}
                  data-cy={`open-client-${record.name}`}
                  placement="bottomRight"
                  overlayStyle={{
                    border: '1px solid #d9d9d9',
                    borderRadius: 2,
                  }}
                  icon={<DownOutlined id={`dropdownExtension${record.name}`} />}
                  overlay={
                    <Menu>
                      <Menu.Item
                        key="0"
                        id={`favorite-client-${record.name}`}
                        onClick={() => this.handleFavoriteClientClick(record, favoriteClient)}
                        icon={favoriteIcon}
                        type="primary"
                      >
                        {!!favoriteClient ? "Remove From Favorites" : "Add To Favorites"}
                      </Menu.Item>
                      <Menu.Item
                        key="1"
                        id={`edit-client-${record.name}`}
                        onClick={() => this.showModalEditClientName(record)}
                        disabled={!canEditClient}
                        icon={<EditOutlined />}
                        type="primary"
                      >
                        Edit Client Name
                      </Menu.Item>
                      <Menu.Item
                        key="2"
                        id={`edit-aws-account-id-${record.name}`}
                        onClick={() => this.showModalEditAwsAccountId(record)}
                        disabled={!canEditClient}
                        icon={<EditOutlined />}
                        type="primary"
                      >
                        Edit AWS Account Id
                      </Menu.Item>
                      <Menu.Item
                        key="3"
                        id={`edit${record.name}`}
                        onClick={() => this.showModalEdit(record)}
                        disabled={!canEditClient}
                        icon={<EditOutlined />}
                        type="primary"
                      >
                        Edit FHIR API URL
                      </Menu.Item>
                      <Menu.Item
                        key="4"
                        id={`edit-dis-api-${record.name}`}
                        onClick={() => this.showModalEditDisUrl(record)}
                        disabled={!canEditClient}
                        icon={<EditOutlined />}
                        type="primary"
                      >
                        Edit DIS API URL
                      </Menu.Item>                      
                      <Menu.Item
                        key="6"
                        id={`exportAll${record.name}`}
                        onClick={() => exportAllMappings(record, 'latest')}
                        icon={<ExportOutlined />}
                        type="primary"
                      >
                        Export All Mappings as CSV
                      </Menu.Item>
                      <Menu.Item
                        key="7"
                        disabled={!canEditClient}
                        id={`delete${record.name}`}
                        onClick={() => this.showModalDel(record)}
                        icon={<DeleteOutlined />}
                        type="primary"
                      >
                        Delete
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <a onClick={() => this.context.setClient(record)}
                      data-cy={"open-client-" + record.id}
                      href={"/map/" + record.id + '/mappings'}>
                      Open
                  </a>
                </Dropdown.Button>
              </Space>
            )
          },
        }
      ]
    );
  }

  getData = async () => {
    const res = await API.get('/client');
    const clients = res.data.clients.sort((a, b) => a.name.localeCompare(b.name));
    this.setState({
      initLoading: false,
      clientListAll: clients,
      clientList: clients.filter(item => item.deleted !== true),
    });
  };

  createClient = async () => {
    const id = uuidv4();
    const res = await API.post(`/client/${id}`, {
      name: this.state.newClientName,
      aws_account_id: this.state.newClientAWSAccountId,
      fhir_api_url: this.state.newClientFHIRURL,
      data_ingest_api_url: this.state.newDisApiUrl,
      id,
    });
    this.setState({
      clientList: this.state.clientList.concat({'name': this.state.newClientName}),
      client: res.data,
    });
  };

  showModalNew = () => this.setState({ isModalVisibleNew: true });

  closeModalNew = () => this.setState({ isModalVisibleNew: false });

  onFinish = async values => {
    const found = this.state.clientListAll.some(el => el.name === values.clientName);

    if (!found) {
      await this.createClient();
      this.props.history.push({
        pathname: `/map/${this.state.client.id}/summary`,
        client: this.state.client,
      });
    } else {
      notification.error({ description: `"${values.clientName}" already exists` });
    }
  };

  updateFhirApiUrl = async () => {
    if (
      this.state.newClientFHIRURL.toLowerCase().startsWith('https://') &&
      this.state.newClientFHIRURL.toLowerCase().endsWith('.com')
    ) {
      const res = await API.put(`/client/${this.state.client.id}`, {
        fhir_api_url: this.state.newClientFHIRURL,
      }).then((res) => {
        this.setState({
          client: res.data,
        });
        notification.success({
          message: 'Success!',
          description: `${this.state.client.name}'s FHIR API URL has been successfully updated`,
          duration: 3,
          placement: 'topLeft',
        });
        this.getData();
      }).catch((e) => {
        notification.error({
          message: 'ERROR: ',
          description: `FHIR API URL failed to update with the following error: ${e}`,
          duration: 6,
          placement: 'topLeft',
        });
      })
    } else {
      notification.error({
        message: 'ERROR: ',
        description: `FHIR API URL entered, ${this.state.newClientFHIRURL}, must begin with 'https://' and end with '.com'`,
        duration: 6,
        placement: 'topLeft',
      });
    };
  };

  /**
   * Determines whether new client name exists in
   * current client list
   *
   * @returns {boolean}
   */
  clientNameExists = () => {
    for (const client of this.state.clientListAll) {
      if (
        client.name.toLowerCase() === this.state.editClientName.toLowerCase().trim() &&
        client.deleted === false
      ){
        return true;
      }
    }
    return false;
  }

  /**
   * Verifies if client name is valid and does not already exist
   * updates client and notifies user.
   */
  updateClientName = async () => {
    if (
      this.state.editClientName.trim().length > 0 &&
      !this.clientNameExists()
    ) {
      await API.put(`/client/${this.state.client.id}`, {
        name: this.state.editClientName.trim(),
      }).then((res) => {
        this.setState({
          client: res.data,
        });
        notification.success({
          message: 'Success!',
          description: `${this.state.client.name}'s name has been successfully updated to ${this.state.editClientName}`,
          duration: 3,
          placement: 'topLeft',
        });
        this.getData();
      }).catch((e) => {
        notification.error({
          message: 'ERROR: ',
          description: `Client Name failed to update with the following error: ${e}`,
          duration: 6,
          placement: 'topLeft',
        });
      })
    } else {
      notification.error({
        message: 'ERROR: ',
        description: `Client Name entered, '${this.state.editClientName}', already exists or is invalid`,
        duration: 6,
        placement: 'topLeft',
      });
    };
  };

  /**
   * Updates client's DIS API URL and notifies user.
   */
   updateDisApi = (newUrl) => {
    if (newUrl.trim().length > 0) {
      API.put(`/client/${this.state.client.id}`, {
        data_ingest_api_url: newUrl.trim(),
      }).then((res) => {
        this.setState({
          client: res.data,
        });
        notification.success({
          message: 'Success!',
          description: `${this.state.client.name}'s DIS API URL has been successfully updated to ${newUrl}`,
          duration: 3,
          placement: 'topLeft',
        });
        this.getData();
      }).catch((e) => {
        notification.error({
          message: 'ERROR: ',
          description: `DIS API URL failed to update with the following error: ${e}`,
          duration: 6,
          placement: 'topLeft',
        });
      }).finally(() => {
        this.setState({newDisApiUrl: ''});
      });
    } else {
      notification.error({
        message: 'ERROR: ',
        description: `DIS API URL entered is blank`,
        duration: 6,
        placement: 'topLeft',
      });
    }
  };

  /**
   * Updates client's AWS Account Id and notifies user.
   */
  updateAwsAccountId = async () => {
    const {newClientAWSAccountId}  = this.state;
    const {id, name} = this.state.client;
    if (
      newClientAWSAccountId.length === 12 &&
      !isNaN(newClientAWSAccountId)
    ) {
      await API.put(`/client/${id}`, {
        aws_account_id: newClientAWSAccountId,
      }).then((res) => {
        this.setState({
          client: res.data,
        });
        notification.success({
          message: 'Success!',
          description: `${name}'s AWS Account Id has been successfully updated to ${newClientAWSAccountId}`,
          duration: 3,
          placement: 'topLeft',
        });
        this.getData();
      }).catch((e) => {
        notification.error({
          message: 'ERROR: ',
          description: `AWS Account Id failed to update with the following error: ${e}`,
          duration: 6,
          placement: 'topLeft',
        });
      })
    } else {
      notification.error({
        message: 'ERROR: ',
        description: `AWS Account Id entered, ${newClientAWSAccountId}, is invalid! Must be a 12 digit number.`,
        duration: 6,
        placement: 'topLeft',
      });
    };
  };

  /**
    * Callback function for Client search / filter.
  */
  searchClients = (e) => {
    this.setState({clientSearchText: e.target.value});
  }

  closeAllModals = () => {
    this.setState({
      isModalVisibleEdit: false,
      isModalVisibleDel: false,
      isModalVisibleEditClient: false,
      isModalVisibleEditAwsAccountId: false,
      isModalVisibleEditDisApi: false,
      isModalVisibleEditName: false,
      submitDisabled: true,
      newDisApiUrl: '',
    });
  }

  showModalDel = item => {
    const modalTitle = (
      <Title level={5}>
        Delete all <span className="client-name">{item.name}</span> mappings
      </Title>
    );
    this.setState({
      isModalVisibleDel: true,
      client: item,
      placeHolder: item.name,
      title: modalTitle,
    });
  };

  showModalEdit = item => {
    const modalTitle = (
      <Title level={5}>
        Update <span className="client-name">{item.name}</span> FHIR API URL
      </Title>
    );
    this.setState({
      isModalVisibleEdit: true,
      client: item,
      placeHolder: item.name,
      title: modalTitle,
    });
  };

  showModalEditClientName = item => {
    const modalTitle = (
      <Title level={5}>
        Change name for client: <span className="client-name">{item.name}</span>
      </Title>
    );
    this.setState({
      isModalVisibleEditName: true,
      client: item,
      placeHolder: item.name,
      title: modalTitle,
    });
  };

  showModalEditAwsAccountId = item => {
    const modalTitle = (
      <Title level={5}>
        Change AWS Account Id for client: <span className="client-name">{item.name}</span>
      </Title>
    );
    this.setState({
      isModalVisibleEditAwsAccountId: true,
      client: item,
      placeHolder: item.name,
      title: modalTitle,
    });
  };

  showModalEditDisName = item => {
    const modalTitle = (
      <Title level={5}>
        Change name for client's DIS Account: <span className="client-name-dis">{item.name}</span>
      </Title>
    );
    this.setState({
      isModalVisibleEditClient: true,
      client: item,
      placeHolder: item.name,
      title: modalTitle,
    });
  };

  showModalEditDisUrl = item => {
    const modalTitle = (
      <Title level={5}>
        Change client's DIS API URL: <span className="client-dis-api">{item.name}</span>
      </Title>
    );
    this.setState({
      isModalVisibleEditDisApi: true,
      client: item,
      placeHolder: item.name,
      title: modalTitle,
    });
  };

  closeModalDel = () => [
    this.setState({ isModalVisibleDel: false }),
    this.setState({ submitDisabled: true }),
  ];

  delClientOnChange = e => {
    this.setState({ delClientName: e.target.value }, () => {
      if (this.state.delClientName === this.state.client.name) {
        this.setState({ submitDisabled: false });
      } else {
        this.setState({ submitDisabled: true });
      }
    });
  };

  // eslint-disable-next-line require-await
  clientListRemove = async client => {
    this.setState({ initLoading: true }, () => {
      API.put(`/client/${client.id}`, { deleted: true });
      this.getData();
    });
  };

  onDelete = async (delClientName, client) => {
    if (client.name === delClientName) {
      try {
        await this.clientListRemove(client).then(
          () => this.getData(),
          notification.success({
            message: 'Success!',
            description: `${delClientName} has been successfully deleted`,
            duration: 3,
            placement: 'topLeft',
          }),
        );
      } catch (e) {
        notification.error({
          message: 'ERROR: ',
          description: `Could not delete client: ${e}`,
          duration: 6,
          placement: 'topLeft',
        });
      }
    } else {
      this.getData();
      notification.error({
        message: 'ERROR: ',
        description: `Client Name entered, ${delClientName}, does not match. You must enter ${client.name} to delete`,
        duration: 6,
        placement: 'topLeft',
      });
    }

    this.formRef.current.setFieldsValue({ clientNameDel: null });
  };

  handleFavoriteClientClick = async ({ id, name }, favClientPreference) => {
    const clientName = name;
    let action = "Add"
    try { 
      // If client is a already a favorite remove existing preference. Else post new preference.
      if (favClientPreference) {
        action = 'Remove'
        await API.delete(`user/current/preferences/${favClientPreference.id}`);
      } else {
        const params = { preferenceType: "favorite_client", value: id }
        await API.post('/user/current/preferences', params)
      }
      // update the context
      const preferences = await fetchUserPreferences();
      this.context.setUserData({ preferences })
      const actionDisplayText = action === 'Add' ? 'Added' : "Removed"
      const message = `${actionDisplayText} ${clientName} as a favorite`
        //render failed to update message
        notification.success({
          message,
          duration: 3,
          placement: 'topLeft',
        });
    } catch (e) {
        const message = `Unable to ${action.toLowerCase()} ${clientName} as a favorite`
        console.log(e)
        //render failed to update message
        notification.error({
          message,
          duration: 3,
          placement: 'topLeft',
        });
    }
  }

  newClientOnChange = e => this.setState({ newClientName: e.target.value });
  newClientNameOnChange = e => this.setState({ editClientName: e.target.value, submitDisabled: false });
  newClientFHIRURLOnChange = e => this.setState({ newClientFHIRURL: e.target.value });
  newClientAWSAccountIdOnChange = e => this.setState({ newClientAWSAccountId: e.target.value });
  filterFavoritesOnChange = checked => this.setState({ filterFavorites: checked });
  newDisApiUrlOnChange = e => this.setState({ newDisApiUrl: e.target.value });

  render() {
    const { clientSearchText, filterFavorites } = this.state;
    const { preferences } = this.context.userData;
    let clientListDisplayed = this.state.clientList.filter(
      (item) => {
        return item.name.toLowerCase().includes(clientSearchText.toLowerCase());
      }
    )
    
    if (filterFavorites) clientListDisplayed = clientListDisplayed.filter(
      (client) => {
        return filterUserPreferences('favorite_client', preferences).find(({value}) =>  value === client.id)
      }
    )

    return (
      <Layout>
        <Modal
          title={this.state.title}
          maskClosable
          visible={this.state.isModalVisibleDel}
          footer={null}
          onCancel={this.closeModalDel}
        >
          <p>To confirm delete, please enter client name exactly as it appears above.</p>
          <br />
          <Form
            name="deleteClient"
            ref={this.formRef}
            onFinish={this.closeModalDel}
          >
            <Form.Item label="Client Name" name="clientNameDel">
              <Input
                placeholder={this.state.placeHolder}
                value={this.state.delClientName}
                onChange={this.delClientOnChange}
              />
            </Form.Item>
            <Form.Item>
              <Button
                disabled={this.state.submitDisabled}
                loading={this.state.isLoadingDelClient}
                type="danger"
                htmlType="submit"
                onClick={e => [
                  e.stopPropagation(),
                  this.onDelete(this.state.delClientName, this.state.client),
                ]}
              >
                Delete
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title={this.state.title}
          maskClosable
          visible={this.state.isModalVisibleEdit}
          footer={null}
          destroyOnClose={true}
          onCancel={this.closeAllModals}
        >
          <Form name="editURL" onFinish={this.closeAllModals}>
            <Form.Item label="FHIR API URL" name="fhirURL">
              <Input
                value={this.state.newClientFHIRURL}
                placeholder="https://api.healthplanfhir.com"
                onChange={this.newClientFHIRURLOnChange}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                onClick={e => [
                  e.stopPropagation(),
                  this.updateFhirApiUrl(),
                ]}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title={this.state.title}
          maskClosable
          visible={this.state.isModalVisibleEditDisApi}
          footer={null}
          destroyOnClose={true}
          onCancel={this.closeAllModals}
        >
          <Form name="editDisUrl" onFinish={this.closeAllModals}>
            <Form.Item label="DIS API URL" name="disApiUrl">
              <Input
                value={this.state.newClientFHIRURL}
                placeholder="https://api.1uphealth.com"
                onChange={this.newDisApiUrlOnChange}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                onClick={e => [
                  e.stopPropagation(),
                  this.updateDisApi(this.state.newDisApiUrl),
                ]}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title={this.state.title}
          maskClosable
          visible={this.state.isModalVisibleEditName}
          footer={null}
          destroyOnClose={true}
          onCancel={this.closeAllModals}
        >
          <Form name="editClientName" onFinish={this.closeAllModals}>
            <Form.Item label="Client Name" name="clientName">
              <Input
                value={this.state.editClientName}
                placeholder="New Client Name"
                onChange={this.newClientNameOnChange}
              />
            </Form.Item>

            <Form.Item>
              <Button
                disabled={this.state.submitDisabled}
                type="primary"
                htmlType="submit"
                onClick={e => [
                  e.stopPropagation(),
                  this.updateClientName(),
                ]}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title={this.state.title}
          maskClosable
          visible={this.state.isModalVisibleEditAwsAccountId}
          footer={null}
          destroyOnClose={true}
          onCancel={this.closeAllModals}
        >
          <Form name="editAwsAccountId" onFinish={this.closeAllModals}>
            <Form.Item label="AWS Account Id" name="awsAccountId">
              <Input
                value={this.state.newClientAWSAccountId}
                placeholder="Client's AWS Account Id"
                onChange={this.newClientAWSAccountIdOnChange}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                onClick={e => [
                  e.stopPropagation(),
                  this.updateAwsAccountId(),
                ]}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title="Create New Client"
          maskClosable
          visible={this.state.isModalVisibleNew}
          footer={null}
          destroyOnClose={true}
          onCancel={this.closeModalNew}
        >
          <Form name="basic" onFinish={this.onFinish}>
            <Form.Item
              label="Client Name"
              name="clientName"
              rules={[{ required: true, message: 'Please input a client name' }]}
            >
              <Input value={this.state.newClientName} onChange={this.newClientOnChange} />
            </Form.Item>
            <Form.Item
              label="AWS Account Id"
              name="awsAccountId"
              rules={[{ required: true, message: 'Please input the AWS Account Id of the client' }]}
            >
              <Input value={this.state.newClientAWSAccountId} onChange={this.newClientAWSAccountIdOnChange} />
            </Form.Item>
            <Form.Item label="FHIR API URL" name="fhirURL">
              <Input
                value={this.state.newClientFHIRURL}
                placeholder="https://api.healthplanfhir.com"
                onChange={this.newClientFHIRURLOnChange}
              />
            </Form.Item>
            <Form.Item
              label="DIS API URL"
              name="disApiURL"
            >
              <Input
                value={this.state.newDisApiUrl}
                placeholder="https://disApi.healthplanfhir.com"
                onChange={this.newDisApiUrlOnChange}
              />
            </Form.Item>
            <Form.Item>
              <Button loading={this.state.isLoadingNewClient} type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        {(process.env.REACT_APP_FEATURE_PERMISSIONS_V2 ?
          checkPermission(this.context.userData.permissions, 'editClient') :
          isAdmin(USER_ROLE)) && (
          <Row style={{ marginTop: 15 }}>
            <Col span={12} offset={2}>
              <Button onClick={this.showModalNew}>New Client</Button>
            </Col>
          </Row>
        )}
        <Row style={{ marginTop: 15 }}>
          <Col span={12} offset={2} style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
            <Input data-cy="search-clients-input" style={{width: '350px'}} addonBefore="Search:"
              onChange={this.searchClients} onFocus={() => logGAEvent('Client Search')}
            />
            <Text style={{ paddingLeft: '20px' }}>Filter Favorites:</Text>
            <Switch size='small' style={{ marginLeft: '8px' }} onChange={this.filterFavoritesOnChange} />;
          </Col>
        </Row>
        <br />
        <Row justify="center">
          <Col span={20}>
            <Table
              columns={this.state.columns}
              rowKey="id"
              className="home-table"
              pagination={{ pageSize: 500, size: 'small' }}
              size="medium"
              loading={this.state.initLoading}
              dataSource={clientListDisplayed}
            />
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default withRouter(Home);
